import TileLayer from 'ol/layer/Tile';
import OSM from 'ol/source/OSM';

// Defines OSM Map OL tile
export const createOSMLayer = (): TileLayer => {
  return new TileLayer({
    source: new OSM({
      wrapX: false
    })
  });
};